<template>
  <ExternalQueryList
      headline="Event Categories"
      endpoint="/api/v2/content-event-categories"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentEventCategory => $router.push(getUrl(contentEventCategory))"
  >
    <template v-slot:default="{ row: contentEventCategory }">
      <td>
        <router-link :to="getUrl(contentEventCategory)">
          {{ contentEventCategory.attributes.name }}
        </router-link>
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/event-categories/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Name'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentEventCategory) {
      return '/portals/' + this.portal.id + '/content/event-categories/' + contentEventCategory.id + '/edit'
    }
  }
}
</script>
